import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CORRESPONDENCE_ACTION_PARTY_FEATURE_KEY,
	CorrespondenceActionPartyState,
	CorrespondenceActionPartyPartialState,
	correspondenceActionPartyAdapter
} from './action-party.reducer';

// Lookup the 'CorrespondenceActionParty' feature state managed by NgRx
export const getCorrespondenceActionPartyState = createFeatureSelector<
	CorrespondenceActionPartyPartialState,
	CorrespondenceActionPartyState
>(CORRESPONDENCE_ACTION_PARTY_FEATURE_KEY);

const { selectAll, selectEntities } = correspondenceActionPartyAdapter.getSelectors();

export const getCorrespondenceActionPartyLoaded = createSelector(
	getCorrespondenceActionPartyState,
	(state: CorrespondenceActionPartyState) => state.loaded
);

export const getCorrespondenceActionPartyError = createSelector(
	getCorrespondenceActionPartyState,
	(state: CorrespondenceActionPartyState) => state.error
);

export const loadingCorrespondenceActionParty = createSelector(
	getCorrespondenceActionPartyState,
	(state: CorrespondenceActionPartyState) => state.loaded
);

export const getAllCorrespondenceActionParty = createSelector(
	getCorrespondenceActionPartyState,
	(state: CorrespondenceActionPartyState) => selectAll(state)
);

export const getCorrespondenceActionPartyEntities = createSelector(
	getCorrespondenceActionPartyState,
	(state: CorrespondenceActionPartyState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getCorrespondenceActionPartyState,
	(state: CorrespondenceActionPartyState) => state.selectedCorrespondenceActionPartyId
);

export const getSelected = createSelector(
	getCorrespondenceActionPartyEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
